import { useMemo } from "react";
import { Button, Col, Modal, Row, Tag, Typography } from "antd";
import moment from "moment";

import { ISimuladorResponse } from "../../interfaces";
import { EItemType } from "../../../SimuladorInteligente/interfaces";

import { formatStringList, formatValue } from "../../../../utils/simulador";
import { STATUS_OPTIONS } from "../../useRespostasSimulador";
import { TEXTO_LINHA_DE_CREDITO_NAO_ENCONTRADA } from "../..";

const { Text } = Typography;

interface IProps {
  visible: boolean;
  response: ISimuladorResponse | null;
  onClose: () => void;
}

export default function ResponseModal({
  visible,
  response,
  onClose,
}: IProps) {
  const isFinished = useMemo(() => {
    return !!response?.fluxo_finalizado_em;
  }, [response]);

  const status = isFinished ? STATUS_OPTIONS[0] : STATUS_OPTIONS[1];

  return (
    <Modal
      title={(
        <div>
          <span>Resposta</span>

          <Tag
            color={status?.color}
            style={{
              marginLeft: 8
            }}
          >
            {status.text}
          </Tag>
        </div>
      )}
      visible={visible}
      className="classmodalDadosContatoInatendimento"
      onOk={onClose}
      onCancel={onClose}
      footer={[
        <Button key="back" onClick={onClose}>
          Fechar
        </Button>,
      ]}
      width={600}
    >
      {
        response && (
          <Row>
            {
              response.respostas.map((e) => (
                <Col
                  key={e.id}
                  span={24}
                  style={{ marginBottom: 5 }}
                >
                  <Row
                    style={e.type === EItemType.COLLECT ? {
                      border: "1px solid #606060",
                      padding: "4px 8px",
                      borderRadius: 4,
                    } : undefined}
                  >
                    <Text strong>{e.table_display_name}:</Text>

                    {
                      typeof e.response === "object" ? (
                        <Row>
                          {
                            e.type === EItemType.COLLECT && (
                              <>
                                {
                                  typeof e.response.map !== "string" && e.response.map((resp) => typeof resp === "string" ? null : (
                                    <Col
                                      key={resp.name}
                                      span={24}
                                    >
                                      <Text strong>{resp.label}:</Text>
                                      <Text style={{ marginLeft: 5 }}>{formatValue({ value: resp.value, format: resp.format })}</Text>
                                    </Col>
                                  ))
                                }
                              </>
                            )
                          }

                          {
                            e.type === EItemType.OPTIONS && Array.isArray(e.response) && (
                              <Text style={{ marginLeft: 5 }}>
                                {formatStringList(e.response)}
                              </Text>
                            )
                          }
                        </Row>
                      ) : (
                        <Text style={{ marginLeft: 5, color: e.result === TEXTO_LINHA_DE_CREDITO_NAO_ENCONTRADA ? "#e84749" : undefined }}>
                          {e.response ? e.format ? formatValue({ value: e.response, format: e.format }) : e.response : e.result}
                        </Text>
                      )
                    }
                  </Row>
                </Col>
              ))
            }

            <Col span={24} style={{ marginBottom: 5 }}>
              <Row>
                <Text strong>{'Fluxo iniciado em: '}</Text>
                <Text style={{ marginLeft: 5 }}>
                  {response.createdAt ? moment(response.createdAt).format('DD/MM/YYYY HH:mm') : ''}
                </Text>
              </Row>
            </Col>

            <Col span={24} style={{ marginBottom: 5 }}>
              <Row>
                <Text strong>{'Fluxo finalizado em: '}</Text>
                <Text style={{ marginLeft: 5 }}>
                  {response.fluxo_finalizado_em ? moment(response.fluxo_finalizado_em).format('DD/MM/YYYY HH:mm') : ''}
                </Text>
              </Row>
            </Col>
          </Row>
        )
      }
    </Modal>
  )
}
